import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "file-manager__list" }
const _hoisted_2 = { class: "desc" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  class: "-link -royalBlue",
  target: "_blank",
  href: "https://support.apple.com/ko-kr/HT207022",
  style: {"font-weight":"600"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "file-image",
  src: "/images/new/file.svg"
}, null, -1)
const _hoisted_7 = { class: "col-body file-info" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-trash" }, null, -1)
const _hoisted_9 = { class: "p-py-3" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 처방전 보기 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_AlertDialog = _resolveComponent("AlertDialog")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_FileViewerDialog = _resolveComponent("FileViewerDialog")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.isSecondOpinion)
        ? (_openBlock(), _createBlock("small", _hoisted_3, _toDisplayString(_ctx.t("file-list.desc.a")), 1))
        : _createCommentVNode("", true),
      (!_ctx.isPx)
        ? (_openBlock(), _createBlock("small", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.t("file-list.desc.b")) + " ", 1),
            _createVNode("a", _hoisted_5, _toDisplayString(_ctx.t("file-list.desc.c")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.t("file-list.desc.d")) + " ", 1),
            _createVNode("b", null, _toDisplayString(_ctx.t("file-list.desc.e")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.t("file-list.desc.f")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.state.list,
      onRowSelect: _ctx.onSelectedRow,
      dataKey: "FileKey",
      selection: _ctx.state.select,
      "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.select = $event)),
      selectionMode: "single",
      class: "data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "Image",
          header: ""
        }, {
          body: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "FileInfo",
          header: ""
        }, {
          body: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_7, [
              _createVNode("span", null, _toDisplayString(slotProps.data.Title), 1),
              _createVNode("span", null, _toDisplayString(slotProps.data.DataType), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "FileKey",
          header: ""
        }, {
          body: _withCtx((slotProps) => [
            (!slotProps.data.RefKeyValue3 || _ctx.isLive)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "file-remove",
                  onClick: _ctx.openModal
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_AlertDialog, {
              visible: _ctx.displayModal,
              acceptLabel: _ctx.t('remove'),
              rejectLabel: _ctx.t('cancel'),
              action: "delete",
              key: slotProps.data.FileKey,
              onRejected: _ctx.closeModal,
              onAccepted: ($event: any) => (_ctx.deleteFile(slotProps.data.FileKey))
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.t("confirm delete file")), 1)
              ]),
              _: 2
            }, 1032, ["visible", "acceptLabel", "rejectLabel", "onRejected", "onAccepted"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "onRowSelect", "selection"]),
    (_ctx.state.visibleFull)
      ? (_openBlock(), _createBlock(_component_FileViewerDialog, {
          key: 0,
          file: _ctx.state.select,
          onClose: _ctx.FileViewerDialogClose
        }, _createSlots({ _: 2 }, [
          (_ctx.state.isPx)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _hoisted_10
                ])
              }
            : undefined
        ]), 1032, ["file", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}